import { render, staticRenderFns } from "./Seminar.vue?vue&type=template&id=801fa82a&scoped=true&"
import script from "./Seminar.vue?vue&type=script&lang=js&"
export * from "./Seminar.vue?vue&type=script&lang=js&"
import style0 from "./Seminar.vue?vue&type=style&index=0&id=801fa82a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "801fa82a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VProgressCircular,VRow,VSpacer})
